import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';
import { Money } from '@websky/core/src/Money';
import Button from '@websky/core/src/Button';
import RecommendedBadge from '@websky/core/src/FareGroup/components/RecommendedBadge/RecommendedBadge';
import Notification from '@websky/core/src/Notification';
import Dialog from '@websky/core/src/Service/components/Dialog/Dialog';
import Modal from '@websky/core/src/Modal';
import CompareFares from '@websky/core/src/CompareFares';
import PriceInMiles from '@websky/core/src/PriceInMiles/PriceInMiles';
import { getUniqueValidOptions } from '@websky/core/src/Results/utils';
import { initI18n, MOBILE_MIN_WIDTH } from '@websky/core/src/utils';
import { FareFeaturePaymentType, InfoMessageTypeEnum } from '@websky/graphql';
import { icons } from './icons';
import css from './FareGroup.css';
initI18n('FareGroup');
const FareGroup = props => {
    const { className, fare, price, upgradeOption, disabledForMiles, priceInMiles, flightId, showUnavailableOptions = false, isDisabled = false, isSelected, onSelect, onUpgrade, renderProps } = props;
    const { t } = useTranslation('FareGroup');
    const [isModalOpen, openModal] = React.useState(false);
    const options = getUniqueValidOptions(fare.options, false, false, showUnavailableOptions);
    const renderOptionItem = (option, index) => {
        const description = `: \n${option.shortDescription || option.value || ''}`;
        return (React.createElement("li", { key: index, "data-option-type": option.type, className: cn(css.option, {
                [css.option_aligned]: !option.value && !option.shortDescription
            }) },
            React.createElement("span", { className: cn(css.option__icon, {
                    [css.option__icon_paid]: option.availability === FareFeaturePaymentType.Pay,
                    [css.option__icon_unavaliable]: option.availability === FareFeaturePaymentType.NotAvailable
                }) }, icons[option.type]),
            React.createElement("span", { className: css.option__title }, `${option.title + description}`)));
    };
    const handleOnSelect = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!isDisabled && onSelect) {
            onSelect();
        }
    };
    return (React.createElement("div", { className: cn(className, css.fareGroup, { [css.fareGroup_unavailable]: isDisabled }) },
        fare.isRecommended && !isDisabled && !isSelected && React.createElement(RecommendedBadge, null),
        React.createElement("div", { className: css.header },
            React.createElement("div", { className: css.title }, fare.title),
            !isDisabled && !priceInMiles && React.createElement(Money, { moneyClassName: css.price, money: price }),
            !!priceInMiles && React.createElement(PriceInMiles, { moneyClassName: css.price, amount: priceInMiles }),
            props.priceInMiles && !props.disabledForMiles && (React.createElement("div", { className: css.taxes },
                t('Taxes'),
                ":",
                React.createElement(Money, { money: price }))),
            !isSelected && (React.createElement(Button, { className: css.button, disabled: isDisabled, variant: "flat", size: "large", onClick: handleOnSelect, "data-tariff": fare.title }, t(isDisabled && !disabledForMiles ? 'Unavailable' : 'Select'))),
            disabledForMiles && (React.createElement(Notification, { type: 'context', status: InfoMessageTypeEnum.Info, infoMessage: {
                    text: t('Not enough miles on your card'),
                    type: InfoMessageTypeEnum.Info,
                    code: ''
                } }))),
        React.createElement("div", { className: css.content },
            options.length && React.createElement("ul", { className: css.options }, options.map(renderOptionItem)),
            upgradeOption && (React.createElement("div", { className: css.upgradeOffer, onClick: onUpgrade },
                React.createElement("span", { className: css.upgradeOffer__title }, upgradeOption.upgradeOffer),
                React.createElement("span", { className: css.upgradeOffer__choose },
                    t('Choose'),
                    " ",
                    upgradeOption.canUpgradeTo.fareFamily.title),
                React.createElement("div", { className: css.upgradeOffer__options },
                    React.createElement("span", { className: css.upgradeOffer__optionsPlus }, "+"),
                    upgradeOption.optionsAvailableOnNextFare.map((option, index) => (React.createElement("div", { key: index, className: css.upgradeOffer__icon }, icons[option])))))),
            (renderProps === null || renderProps === void 0 ? void 0 : renderProps.renderButton) && renderProps.renderButton(props),
            (renderProps === null || renderProps === void 0 ? void 0 : renderProps.renderRulesButton) && renderProps.renderRulesButton(props)),
        React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH },
            React.createElement(Dialog, { isOpen: isModalOpen, dialogType: "fullscreen", dialogHeaderClassName: css.dialog__header, dialogContentClassName: css.dialog__content, dialogHeader: t('Compare fare families'), onClose: () => openModal(false), content: React.createElement(CompareFares, { code: fare.airline.iata, flightId: flightId }), mountOnEnter: true })),
        React.createElement(MediaQuery, { minWidth: +MOBILE_MIN_WIDTH + 1 },
            React.createElement(Modal, { open: isModalOpen, onClose: () => openModal(false) },
                React.createElement(CompareFares, { code: fare.airline.iata, flightId: flightId })))));
};
export default FareGroup;
